import { Box, NavLink } from '@mantine/core';
import SuperAdminArea from '../../SuperAdmin/SuperAdminArea';
import StoreSectionPreview from '../StoreSectionPreview';
import { visibleSections } from '../chatBotTabs';
import BehaviourContextSection from './BehaviourContextSection';
import ButtonsCardsSection from './ButtonsCardsSection';
import CatalogSearchSection from './CatalogSearchSection';
import HistorySection from './HistorySection';
import KnowledgeSection from './KnowledgeSection';
import ModelRuntimeSection from './ModelRuntimeSection';
import ProductFeedsSection from './ProductFeedsSection';
import classes from './SuperAdminSections.module.css';

const SECTION_COMPONENTS = {
  modelRuntime: ModelRuntimeSection,
  catalogSearch: CatalogSearchSection,
  behaviourContext: BehaviourContextSection,
  buttonsCards: ButtonsCardsSection,
  productFeeds: ProductFeedsSection,
  knowledge: KnowledgeSection,
  history: HistorySection,
  storeSection: StoreSectionPreview,
};

/**
 * The super admin block under the chat bot tabs: a rail of sections on the left, the selected one
 * on the right. `section` is already resolved (see resolveSection); every section gets the same props
 * (onSectionChange included, for links between sections) and reads the ones it needs.
 */
const SuperAdminSections = ({ section, onSectionChange, ...props }) => {
  const Section = SECTION_COMPONENTS[section];

  return (
    <SuperAdminArea show mt="md">
      <Box className={classes.layout}>
        <Box component="nav" className={classes.rail} aria-label="Super admin sections">
          {visibleSections(props.chatBot).map(({ id, label }) => (
            <NavLink
              key={id}
              component="button"
              type="button"
              label={label}
              active={id === section}
              aria-current={id === section ? 'page' : undefined}
              onClick={() => onSectionChange(id)}
              variant="filled"
              py={6}
            />
          ))}
        </Box>
        <Box className={classes.content}>
          <Section {...props} onSectionChange={onSectionChange} />
        </Box>
      </Box>
    </SuperAdminArea>
  );
};

export default SuperAdminSections;
